import { Component, OnInit , NgZone} from '@angular/core';
import { AppService } from '../app.service';
import { NbSidebarService, NbMenuService } from '@nebular/theme';
import { AuthService } from '../auth.service';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  constructor(public appService: AppService, private nbService: NbSidebarService, private nbMenuService: NbMenuService, public auth: AuthService) {

  }

  ngOnInit() { }


}
